import { useEffect, useState } from 'react';
import { fetchJson, type SessionUser } from '@/lib/api';

type State =
  | { loading: true }
  | { loading: false; user: SessionUser | null };

export function useSession() {
  const [state, setState] = useState<State>({ loading: true });
  useEffect(() => {
    let cancelled = false;
    fetchJson<SessionUser>('/api/session')
      .then((u) => {
        if (!cancelled) setState({ loading: false, user: u });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, user: null });
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return state;
}
